import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=035d4e7e&scoped=true"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=035d4e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d4e7e",
  null
  
)

export default component.exports